/**
 * ErrorIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const ErrorIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M14.387 8.295a.913.913 0 0 1 1.286 0 .9.9 0 0 1 0 1.28l-2.387 2.375 2.387 2.375a.9.9 0 0 1 0 1.28.913.913 0 0 1-1.286 0L12 13.23l-2.387 2.375a.913.913 0 0 1-1.286 0 .9.9 0 0 1 0-1.28l2.387-2.375-2.387-2.375a.9.9 0 0 1 0-1.28.913.913 0 0 1 1.286 0L12 10.67z" />
    <path
      fillRule="evenodd"
      d="M14.425 2c1.315 0 2.57.475 3.47 1.471l2.727 2.714C21.515 7.073 22 8.315 22 9.639v4.723c0 1.31-.478 2.557-1.479 3.453l-2.727 2.714c-.973.968-2.212 1.471-3.471 1.471H9.677l-.083-.004c-1.286-.116-2.507-.59-3.489-1.567l-2.727-2.714C2.485 16.827 2 15.585 2 14.261V9.64c0-1.312.478-2.563 1.483-3.459l2.723-2.709C7.106 2.475 8.361 2 9.677 2zM9.677 3.81c-.887 0-1.633.316-2.144.897l-.042.043-2.727 2.714-.044.041c-.584.508-.901 1.251-.901 2.134v4.622c0 .888.323 1.656.844 2.175l2.728 2.714c.627.624 1.416.952 2.337 1.041h4.595c.761 0 1.543-.301 2.186-.941l2.727-2.714.043-.041c.585-.508.902-1.25.902-2.133V9.64c0-.888-.323-1.657-.844-2.175L16.609 4.75l-.041-.043c-.511-.581-1.257-.897-2.144-.897z"
      clipRule="evenodd"
    />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const ErrorIcon = makeIcon('ErrorIcon', ErrorIconSvg)
